var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ecology-plane-comparison-container" }, [
    _c("a", { on: { click: _vm.prevPage } }, [
      _c("img", { attrs: { src: "/imgs/icons/icon-arrow-left.webp" } })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "ecology-plane-comparison-main" }, [
      _c("div", { staticClass: "ecology-plane-comparison-carousel" }, [
        _c(
          "div",
          { staticClass: "ecology-plane-comparison-carousel-container" },
          [
            _c(
              "div",
              {
                staticClass:
                  "ecology-plane-comparison-carousel-container-inner",
                style: { "margin-left": "-" + _vm.offset + "%" }
              },
              _vm._l(_vm.planes, function(plane, i) {
                return _c(
                  "a",
                  {
                    key: i,
                    staticClass: "plane-card",
                    attrs: { href: plane.url }
                  },
                  [
                    _c("img", { attrs: { src: plane.image } }),
                    _vm._v(" "),
                    _c("div", { staticClass: "plane-name" }, [
                      _vm._v(
                        "\n                            " +
                          _vm._s(plane.name) +
                          "\n                        "
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "features" }, [
                      _c("div", { staticClass: "feature" }, [
                        _c("div", { staticClass: "feature-label" }, [
                          _vm._v(_vm._s(_vm.$t("pages.co2-emissions-per-km")))
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "feature-value" }, [
                          _vm._v(_vm._s(plane.co2_emissions) + " kg")
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "feature" }, [
                        _c("div", { staticClass: "feature-label" }, [
                          _vm._v(_vm._s(_vm.$t("pages.consumption")))
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "feature-value" }, [
                          _vm._v(_vm._s(plane.consumption) + " L / 100km*")
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "footer" }, [
                      _vm._v(
                        "\n                            " +
                          _vm._s(
                            _vm.$t("pages.less-than-a-jet", {
                              percentage: plane.gain_over_jet
                            })
                          ) +
                          "\n                        "
                      )
                    ])
                  ]
                )
              }),
              0
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "footnotes" }, [
        _c("div", [_vm._v("* " + _vm._s(_vm.$t("pages.per-passenger")))]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            "** " + _vm._s(_vm.$t("pages.comparison-with-cessna-latitude"))
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("a", { on: { click: _vm.nextPage } }, [
      _c("img", { attrs: { src: "/imgs/icons/icon-arrow-right.webp" } })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c229f554", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c229f554","hasScoped":true,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/EcologyPlaneComparison.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-c229f554","hasScoped":true,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/EcologyPlaneComparison.vue
// module chunks = 1 2 3